/**
 * Scroll the quote request form into view if it's not already.
 *
 * @depends moveTo.js
 */
function scrollForm(formElement) {
	let targetElement = formElement;

	const anchor = document.querySelector('.quote_form_anchor');
	const rebrandAnchor = document.querySelector('.js-rebrand-quote-form-anchor');

	let tolerance = -12;

	if (anchor) {
		targetElement = anchor;
	} else if (rebrandAnchor) {
		targetElement = rebrandAnchor;
		formElement = targetElement;
		tolerance = 36;
	}

	// Scroll up only if the form is above the viewport.
	if (formElement.getBoundingClientRect().top < 0) {
		const y = targetElement.getBoundingClientRect().top + window.scrollY - tolerance;

		console.log('Scrolling quote request form into place...');
		window.scrollTo({
			top: y,
			behavior: 'smooth',
		});
	}
}

export {
	scrollForm
}